export const getRemainingSecondsLabel = (remaining: number): string => {
  return `${remaining} s`;
};
